module.exports = __webpack_public_path__ + "img/talent-pool.2ab5024c.svg";